var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"btn",class:_vm.classes,on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_vm._t("default"),_c('span',{staticClass:"font-h2",domProps:{"textContent":_vm._s(_vm.text)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }